// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export interface NotificationHeader {
  id: string;
  name: string;
  content: string;
  html_content?: string;
  is_default: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const useNotificationHeaders = () => {
  const [headers, setHeaders] = useState<NotificationHeader[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchHeaders = async () => {
    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('notification_headers')
        .select('*')
        .eq('is_active', true)
        .order('is_default', { ascending: false })
        .order('name');

      if (error) {
        console.error('Error fetching headers:', error);
        return;
      }

      setHeaders(data || []);
    } catch (error) {
      console.error('Error fetching headers:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHeaders();
  }, []);

  const createHeader = async (headerData: Omit<NotificationHeader, 'id' | 'created_at' | 'updated_at'>) => {
    try {
      const { data, error } = await supabase
        .from('notification_headers')
        .insert([headerData])
        .select()
        .single();

      if (error) {
        console.error('Error creating header:', error);
        return null;
      }

      await fetchHeaders();
      return data;
    } catch (error) {
      console.error('Error creating header:', error);
      return null;
    }
  };

  const updateHeader = async (id: string, updates: Partial<NotificationHeader>) => {
    try {
      const { error } = await supabase
        .from('notification_headers')
        .update(updates)
        .eq('id', id);

      if (error) {
        console.error('Error updating header:', error);
        return false;
      }

      await fetchHeaders();
      return true;
    } catch (error) {
      console.error('Error updating header:', error);
      return false;
    }
  };

  const deleteHeader = async (id: string) => {
    try {
      const { error } = await supabase
        .from('notification_headers')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting header:', error);
        return false;
      }

      await fetchHeaders();
      return true;
    } catch (error) {
      console.error('Error deleting header:', error);
      return false;
    }
  };

  return {
    headers,
    isLoading,
    createHeader,
    updateHeader,
    deleteHeader,
    refetch: fetchHeaders
  };
};